import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-check",
  "use": "tamr-icon-check-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-check\"><path d=\"M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm0,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30Z\" /><path d=\"M23.3,10.3L13.1,19.6,8.8,14.4a1,1,0,1,0-1.5,1.3l5,6a1,1,0,0,0,.7.4H13l0.7-.3,11-10A1,1,0,1,0,23.3,10.3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol